export default function createQueryStringObject(searchStrings: URLSearchParams): Record<string, string> {
  const obj: Record<string, string> = {};

  searchStrings.forEach((value: string, key: string) => {
    obj[key] = value;
  });

  return obj;
}

export function cleanParamsForUrl<T extends object>(params: T): Record<string, string> {
  return Object.entries(params).reduce<Record<string, string>>((acc, [key, value]) => {
    if (value !== undefined && value !== null) {
      acc[key] = String(value);
    }

    return acc;
  }, {});
}
